import { render } from "./TimeMachine.vue?vue&type=template&id=7d51e318&ts=true"
import script from "./TimeMachine.vue?vue&type=script&lang=ts"
export * from "./TimeMachine.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__